<ion-content>
  <nav class="side-menu" aria-label="Business menu">
    <header class="sm-hero">
      <button type="button" class="sm-close" (click)="closeMenu()" aria-label="Close menu">
        <ion-icon name="close" aria-hidden="true"></ion-icon>
      </button>

      <div class="sm-avatar is-logo">
        <app-business-avatar [avatarUrl]="_imageUrl" (upload)="updateImage($event)"></app-business-avatar>
        <label class="sm-avatar-badge" for="single" aria-label="Change business logo">
          <ion-icon name="camera" aria-hidden="true"></ion-icon>
        </label>
      </div>

      <h2 class="sm-name">{{ businessName }}</h2>
      @if (roleLabel) {
        <span class="sm-role">{{ roleLabel }}</span>
      }
      <div>
        <button type="button" class="sm-profile-link" (click)="goToMyProfile()">
          View Business Profile
          <ion-icon name="chevron-forward" aria-hidden="true"></ion-icon>
        </button>
      </div>
    </header>

    <section class="sm-switches" aria-label="Portals">
      <button type="button" class="sm-switch" (click)="switchToUserPortal()">
        <span class="sm-switch-icon" aria-hidden="true"><ion-icon name="person"></ion-icon></span>
        <span>
          <span class="sm-switch-title">Switch to User Portal</span>
          <span class="sm-switch-note">Give and browse as yourself</span>
        </span>
        <ion-icon name="swap-horizontal" aria-hidden="true"></ion-icon>
      </button>
    </section>

    <section class="sm-section" aria-labelledby="sm-sales">
      <h3 class="sm-eyebrow" id="sm-sales">Sales &amp; giving</h3>
      <ul class="sm-list">
        <li>
          <button type="button" class="sm-row" (click)="goToOrders()">
            <span class="sm-row-icon" aria-hidden="true"><ion-icon name="receipt-outline"></ion-icon></span>
            <span class="sm-row-text">
              <span class="sm-row-title">Orders</span>
              <span class="sm-row-note">View and fulfill orders</span>
            </span>
            <ion-icon class="sm-chevron" name="chevron-forward" aria-hidden="true"></ion-icon>
          </button>
        </li>
        @if (canViewDonationHistory) {
          <li>
            <button type="button" class="sm-row" (click)="goToDonationHistory()">
              <span class="sm-row-icon" aria-hidden="true"><ion-icon name="gift-outline"></ion-icon></span>
              <span class="sm-row-text">
                <span class="sm-row-title">Donation History</span>
                <span class="sm-row-note">View business donations</span>
              </span>
              <ion-icon class="sm-chevron" name="chevron-forward" aria-hidden="true"></ion-icon>
            </button>
          </li>
        }
        <li>
          <button type="button" class="sm-row" (click)="goToShopifyManagement()">
            <span class="sm-row-icon" aria-hidden="true"><ion-icon name="cart-outline"></ion-icon></span>
            <span class="sm-row-text">
              <span class="sm-row-title">Shopify Management</span>
              <span class="sm-row-note">Manage your Shopify integration</span>
            </span>
            <ion-icon class="sm-chevron" name="chevron-forward" aria-hidden="true"></ion-icon>
          </button>
        </li>
      </ul>
    </section>

    <section class="sm-section" aria-labelledby="sm-manage">
      <h3 class="sm-eyebrow" id="sm-manage">Manage</h3>
      <ul class="sm-list">
        @if (canViewDonationHistory) {
          <li>
            <button type="button" class="sm-row" (click)="goToStripeManagement()">
              <span class="sm-row-icon" aria-hidden="true"><ion-icon name="card-outline"></ion-icon></span>
              <span class="sm-row-text">
                <span class="sm-row-title">Stripe Connect</span>
                <span class="sm-row-note">Manage your Stripe account</span>
              </span>
              <ion-icon class="sm-chevron" name="chevron-forward" aria-hidden="true"></ion-icon>
            </button>
          </li>
        }
        <li>
          <button type="button" class="sm-row" (click)="goToTeamManagement()">
            <span class="sm-row-icon" aria-hidden="true"><ion-icon name="person-add-outline"></ion-icon></span>
            <span class="sm-row-text">
              <span class="sm-row-title">Team Management</span>
              <span class="sm-row-note">Invite and manage team members</span>
            </span>
            <ion-icon class="sm-chevron" name="chevron-forward" aria-hidden="true"></ion-icon>
          </button>
        </li>
        <li>
          <button type="button" class="sm-row" (click)="goToSettings()">
            <span class="sm-row-icon" aria-hidden="true"><ion-icon name="settings-outline"></ion-icon></span>
            <span class="sm-row-text">
              <span class="sm-row-title">Settings</span>
              <span class="sm-row-note">Preferences, donation visibility</span>
            </span>
            <ion-icon class="sm-chevron" name="chevron-forward" aria-hidden="true"></ion-icon>
          </button>
        </li>
      </ul>
    </section>

    <footer class="sm-footer">
      <ul class="sm-list">
        <li>
          <button type="button" class="sm-row is-danger" (click)="signOut()">
            <span class="sm-row-icon" aria-hidden="true"><ion-icon name="log-out-outline"></ion-icon></span>
            <span class="sm-row-text">
              <span class="sm-row-title">Log Out</span>
            </span>
            <span aria-hidden="true"></span>
          </button>
        </li>
      </ul>
    </footer>
  </nav>
</ion-content>
